{
  "version": 1,
  "asset_id": "8ab9f088-0924-4447-a44c-50fe4ccfeada",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8ab9f088-0924-4447-a44c-50fe4ccfeada/bypass-revision-resection-en.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8ab9f088-0924-4447-a44c-50fe4ccfeada/bypass-revision-resection-en.png",
  "original_filename": "bypass-revision-resection-en.png",
  "size": 1346408,
  "content_type": "image/png",
  "created_at": "2026-10-05T22:41:23Z"
}
